import util from '@/common/util.js';
export const getEstPrice = function(params) {
    if (util.inCmsPageEditor) {
        return import(
            /* webpackChunkName: "sold_estimate_mock"*/ './cms-mock'
        ).then(res => {
            //  right   result in a deep copy
            return Promise.resolve(JSON.parse(JSON.stringify(res)));
        });
    }
    return this.axiosIns.get('/api-site/evaluation/address', { params });
};
export default {
    getEstPrice: getEstPrice
};
